import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, toImage } from "../util.js"

rendererResolvers.push(
	({ toRel, item }) => {
		if (item != Item.THRUSTER)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const imgBase = await getImage("thruster_base")
				const imgThruster = await getImage("thruster")

				const canvas = createCanvas(128, imgBase.height)
				const ctx = canvas.getContext("2d")

				ctx.drawImage(imgBase, -32, 0)
				ctx.rotate(-90 * (Math.PI / 180))
				ctx.drawImage(imgThruster, -imgThruster.width * 2, imgThruster.height / 2 - 52)

				return [{
					image: await toImage(canvas),
					texturePosOff: toRel(-8, 0),
					textureSizeOff: toRel(88, 0),
					baseBoundOff: { x: 0.2, y: 0.2 } // original bounds are 0.2 smaller
				}]
			}
		}
	}
)
